var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { model: _vm.ruleForm, rules: _vm.rules, "label-width": "120px" },
    },
    [
      _c(
        "div",
        { staticStyle: { "max-height": "400px", "overflow-y": "scroll" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("yhzh"), prop: "account" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "account", $$v)
                          },
                          expression: "ruleForm.account",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("yhxm"), prop: "nickname" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.nickname,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "nickname", $$v)
                          },
                          expression: "ruleForm.nickname",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("sjhm"), prop: "phone" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "phone", $$v)
                          },
                          expression: "ruleForm.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("mm"), prop: "pwd" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          disabled: "",
                          type: "password",
                          "show-password": "",
                        },
                        model: {
                          value: _vm.ruleForm.pwd,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "pwd", $$v)
                          },
                          expression: "ruleForm.pwd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("czmm") } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          disabled: "",
                          "show-password": "",
                          type: "password",
                        },
                        model: {
                          value: _vm.ruleForm.operation_pwd,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "operation_pwd", $$v)
                          },
                          expression: "ruleForm.operation_pwd",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("yhye") } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "", type: "number" },
                        model: {
                          value: _vm.ruleForm.now_money,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "now_money", $$v)
                          },
                          expression: "ruleForm.now_money",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("xdsxf") } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "", type: "number" },
                        model: {
                          value: _vm.ruleForm.create_order_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "create_order_rate", $$v)
                          },
                          expression: "ruleForm.create_order_rate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("txsxf") } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "", type: "number" },
                        model: {
                          value: _vm.ruleForm.user_withdraw_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "user_withdraw_rate", $$v)
                          },
                          expression: "ruleForm.user_withdraw_rate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("sfzh"), prop: "idcard" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.ruleForm.idcard,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "idcard", $$v)
                          },
                          expression: "ruleForm.idcard",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: _vm.$t("sfzzp") } }, [
                    _vm.ruleForm.idcard_img
                      ? _c("div", { staticClass: "pictrue" }, [
                          _c("img", {
                            attrs: { src: _vm.setUrl(_vm.ruleForm.idcard_img) },
                          }),
                        ])
                      : _c("div", { staticClass: "upLoad" }, [
                          _c("i", {
                            staticClass: "el-icon-camera cameraIconfont",
                          }),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("vipdj") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            disabled: "",
                            placeholder: _vm.$t("qxz"),
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.ruleForm.level_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "level_id", $$v)
                            },
                            expression: "ruleForm.level_id",
                          },
                        },
                        _vm._l(_vm.levelList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.level_name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("status") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("zhengchang"))),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("jinyong"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("djsj") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled: "",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd hh:mm:ss",
                          format: "yyyy-MM-dd hh:mm:ss",
                          placeholder: _vm.$t("qxz"),
                        },
                        model: {
                          value: _vm.ruleForm.user_freeze_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "user_freeze_time", $$v)
                          },
                          expression: "ruleForm.user_freeze_time",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("txzt") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.ruleForm.withdraw_status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "withdraw_status", $$v)
                            },
                            expression: "ruleForm.withdraw_status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(" " + _vm._s(_vm.$t("ktx")) + " "),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(" " + _vm._s(_vm.$t("jinyong")) + " "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("yhkxx"), name: "first" },
              }),
              _vm._v(" "),
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("qbxx"), name: "second" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankmc") },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.bank_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "bank_name", $$v)
                  },
                  expression: "ruleForm.bank_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankzhmc") },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.bank_branch_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "bank_branch_name", $$v)
                  },
                  expression: "ruleForm.bank_branch_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "first",
                  expression: "activeName == 'first'",
                },
              ],
              attrs: { label: _vm.$t("bankzh") },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.bank_account,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "bank_account", $$v)
                  },
                  expression: "ruleForm.bank_account",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "second",
                  expression: "activeName == 'second'",
                },
              ],
              attrs: { label: _vm.$t("qbmc") },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.wallet_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "wallet_name", $$v)
                  },
                  expression: "ruleForm.wallet_name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "second",
                  expression: "activeName == 'second'",
                },
              ],
              attrs: { label: _vm.$t("qbdz") },
            },
            [
              _c("el-input", {
                staticClass: "selWidth",
                attrs: { disabled: "" },
                model: {
                  value: _vm.ruleForm.wallet_address,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "wallet_address", $$v)
                  },
                  expression: "ruleForm.wallet_address",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin_top_20 flex-end" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("ruleForm")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("guanbi")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }